import { isSSR } from "@shared/utils/fullscriptEnv/fullscriptEnv";

interface Params {
  origin?: string;
  pathname?: string;
}

const checkHostAndPathForEmerson = (host: string, path: string = "") => {
  // Production && Emerson Dev Env
  if (host.includes("emersonecologics") || host.includes("emerson.np.fs")) {
    return true;
  }

  // Review/Staging/Localhost Env
  return path.startsWith("/emerson");
};
/**
 * Used to verify if the current app is Emerson or Fullscript.
 * @see `app/javascript/shared/hooks/useCheckIsEmerson/useCheckIsEmerson.ts` hook usage.
 * ⚠️ 99% of the time you will want to use `useCheckIsEmerson`
 *
 * @param param0
 * @returns
 */
const checkIsEmerson = (url: string | Params | URL = {}) => {
  let host: string | undefined;
  let path: string | undefined;

  if (isSSR()) {
    const { pathname, origin } = typeof url === "string" ? new URL(url) : url;
    host = origin;
    path = pathname;
  } else {
    host = window.location.hostname;
    path = window.location.pathname;
  }

  return host ? checkHostAndPathForEmerson(host, path) : false;
};

export { checkIsEmerson, checkHostAndPathForEmerson };
